import { render, staticRenderFns } from "./RawEditor2.vue?vue&type=template&id=5dbee0f2"
import script from "./RawEditor2.vue?vue&type=script&lang=js"
export * from "./RawEditor2.vue?vue&type=script&lang=js"
import style0 from "./RawEditor2.vue?vue&type=style&index=0&id=5dbee0f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports